import script from "./QuizBattle.vue?vue&type=script&setup=true&lang=js"
export * from "./QuizBattle.vue?vue&type=script&setup=true&lang=js"

import "./QuizBattle.vue?vue&type=style&index=0&id=650368a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-650368a4"]])

export default __exports__